const suggestionDb = require('./purchase-db')
const dtHandler = require('../../../../../components/dt/dt-handler')

export function init(detail) {
    // Mes Actual
    bestProviderItemTable(detail)

    // Históricos
    // bestProviderItemTableHistory(detail)

    const cont = document.querySelector('#purchase-page-right .title');
    const date = new Date();
    const monthName = date.toLocaleString('en-US', { month: 'long' });
    cont.innerHTML = `Items performance on ${monthName}`

    // const contHistory = document.querySelector('#suggestion-page-right .title');
    // if (contHistory) contHistory.innerHTML = "Historical Performance";

    return
}

// --- TABLAS MES ACTUAL ---

function bestProviderItemTable(detail) {
    suggestionDb.load(
        { 'file': 'provider_item_best_ten', 'filter': 'current', 'limit': '30' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];

            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#purchase-provider-item-last-movements').innerHTML = bestTable;
            document.querySelector('#purchase-provider-item-lower-movements').innerHTML = lowerTable;
        }
    )
}

// --- TABLAS HISTÓRICAS (Misma estructura, IDs con -history) ---

function bestProviderItemTableHistory(detail) {
    suggestionDb.load(
        { 'file': 'provider_item_best_ten', 'filter': 'all' },
        (result) => {
            const columns = [
                { key: 'item_name', label: 'Name', format: '', behavior: false, title: "" },
                { key: 'provider_name', label: 'Provider', format: '', behavior: false, title: "" },
                { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: "" },
                { key: 'roi', label: 'ROI Star', behavior: true, displayText: false, title: false },
                { key: 'profit', label: 'Profit', format: 'star', behavior: false, title: "" },
                { key: 'profit', label: 'Profit Star', behavior: true, displayText: false, title: false },
            ];
            const bestTable = dtHandler.dtSimpleFc(result.data, columns);
            const lowerTable = dtHandler.dtSimpleFc(result.low_profit, columns);

            document.querySelector('#suggestion-provider-item-last-movements-history').innerHTML = bestTable;
            document.querySelector('#suggestion-provider-item-lower-movements-history').innerHTML = lowerTable;
        }
    )
}